import Button from '@codegouvfr/react-dsfr/Button';
import React from 'react';
import { FallbackProps, getErrorMessage } from 'react-error-boundary';
import { FrServerIcon } from './components/FrServerIcon';

export const ServiceUnavailable = ({ error, resetErrorBoundary }: FallbackProps) => {
  const message = getErrorMessage(error) ?? '';

  const handleBack = () => window.history.back();
  const handleRetry = () => resetErrorBoundary();

  return (
    <div className="min-h-screen p-4 flex items-center justify-center h-screen" style={{ height: '100vh' }}>

      <div className="fr-grid-row fr-grid-row--center fr-grid-row--gutters w-full">

        <div className="fr-server__body fr-col-12 fr-col-md-6">

          <h1 className="fr-h1">L'application a rencontré une erreur</h1>

          <p className="fr-text--xl">Vous serez bientôt en mesure d'utiliser ce service.</p>

          <p>{message}</p>

          <br />

          <div className="flex gap-4">
            <Button onClick={handleBack}>Retour</Button>
            <Button priority="tertiary" onClick={handleRetry}>Réessayer</Button>
          </div>
        </div>

        <FrServerIcon />
      </div>
    </div>
  );
};
